import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

let   sliderContainer = document.querySelectorAll('.slider');
let   sliderSwiper    = {};


if ( sliderContainer ) {
  Array.from(sliderContainer).forEach((slider, number) => {
    sliderSwiper[number] = new Swiper(
      slider.querySelector('.swiper'),
      {
        slidesPerView: 1.2,
        slideClass: slider.dataset.slide,
        spaceBetween: 20,
        navigation: {
          prevEl: slider.querySelector('.button--prev'),
          nextEl: slider.querySelector('.button--next')
        },
        breakpoints: {
          375: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          576: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        }
      }
    );
  });
}
